import { PageBreadcrumbItem } from 'components/common/PageBreadcrumb';
import icon1 from 'assets/img/spot-illustrations/13.png';
import icon1Dark from 'assets/img/spot-illustrations/dark_13.png';
import icon2 from 'assets/img/spot-illustrations/14.png';
import icon2Dark from 'assets/img/spot-illustrations/dark_14.png';
import icon3 from 'assets/img/spot-illustrations/15.png';
import icon3Dark from 'assets/img/spot-illustrations/dark_15.png';
import icon4 from 'assets/img/spot-illustrations/16.png';
import icon4Dark from 'assets/img/spot-illustrations/dark_16.png';
import { BadgeBg } from 'components/base/Badge';
import bg8 from 'assets/img/bg/8.png';
import darkBg8 from 'assets/img/bg/8-dark.png';
import bg9 from 'assets/img/bg/9.png';
import darkBg9 from 'assets/img/bg/9-dark.png';
import bg10 from 'assets/img/bg/10.png';
import darkBg10 from 'assets/img/bg/10-dark.png';
import bg11 from 'assets/img/bg/bg-11.png';
import darkBg11 from 'assets/img/bg/bg-11-dark.png';
import rocket from 'assets/img/spot-illustrations/rocket.png';
import rocketDark from 'assets/img/spot-illustrations/rocket-dark.png';
import bag from 'assets/img/spot-illustrations/bag-2.png';
import bagDark from 'assets/img/spot-illustrations/bag-2-dark.png';
import star from 'assets/img/spot-illustrations/star.png';
import starDark from 'assets/img/spot-illustrations/star-dark.png';
import shield from 'assets/img/spot-illustrations/shield-2.png';
import shieldDark from 'assets/img/spot-illustrations/shield-2-dark.png';

export const pricingBreadcrumbItems: PageBreadcrumbItem[] = [
  {
    label: 'Pages',
    url: '#!'
  },
  {
    label: 'Pricing',
    url: '#!',
    active: true
  }
];

export type Feature = {
  id: string;
  label: string;
  new?: boolean;
};

export interface PricingColumn {
  id: number;
  title: string;
  icon: string;
  iconDark: string;
  description: string;
  price: number;
  features: string[];
  selected?: boolean;
}

export const pricingColumnFeatures: Feature[] = [
  {
    id: 'advanced_search',
    label: 'Advanced Search'
  },
  {
    id: 'custom_fields',
    label: 'Custom fields',
    new: true
  },
  {
    id: 'task_dependencies',
    label: 'Task dependencies'
  },
  {
    id: 'private_teams',
    label: 'Private teams & projects'
  }
];

export const pricingGridFeatures: Feature[] = [
  {
    id: 'timeline',
    label: 'Timeline'
  },
  {
    id: 'advanced_search',
    label: 'Advanced Search'
  },
  {
    id: 'custom_fields',
    label: 'Custom fields',
    new: true
  },
  {
    id: 'task_dependencies',
    label: 'Task dependencies'
  },
  {
    id: 'additional-space',
    label: '20TB of additional space'
  },
  {
    id: 'bandwidth',
    label: 'Bandwidth of  Upto 1 Gbps'
  },
  {
    id: 'private_teams',
    label: 'Private teams & projects'
  },
  {
    id: 'early-access',
    label: 'Early Access / Beta Features'
  }
];

export const pricingColumnItems: PricingColumn[] = [
  {
    id: 1,
    title: 'FREE',
    icon: icon1,
    iconDark: icon1Dark,
    description:
      'Template library, animated elements, stock images and videos, knowledgebase',
    price: 0,
    features: ['1 user']
  },
  {
    id: 2,
    title: 'PRO',
    icon: icon2,
    iconDark: icon2Dark,
    description:
      'Everything in FREE plus private decks, detailed analytics, no NuPitch watermark, script upload, cname, email support',
    price: 1000,
    features: ['timeline', '50 concurrent projects']
  },
  {
    id: 3,
    title: 'AGENCY',
    icon: icon3,
    iconDark: icon3Dark,
    description:
      'Everything in Pro plus: premium stock assests, email DKIM, phone support',
    price: 49.99,
    selected: true,
    features: ['50 users', '500 concurrent projects', 'unlimited templates']
  },
  {
    id: 4,
    title: 'Enterprise',
    icon: icon4,
    iconDark: icon4Dark,
    description: 'Contact us for more information',
    price: 149.99,
    features: ['', '', '', '', '']
  }
];

export interface PricingGrid {
  id: number;
  title: string;
  description: string;
  img: string;
  imgDark: string;
  bg: string;
  darkBg: string;
  monthlyPrice: number;
  yearlyPrice: number;
  features: string[];
  badge?: {
    label: string;
    badgeBg: BadgeBg;
  };
  selected?: boolean;
}

export const pricingGridItems: PricingGrid[] = [
  {
    id: 1,
    title: 'FREE',
    description: `Template library, animated elements, stock images and videos, knowledgebase`,
    img: rocket,
    imgDark: rocketDark,
    bg: bg8,
    darkBg: darkBg8,
    monthlyPrice: 0,
    yearlyPrice: 0,
    features: ['1 user', '1 concurrent project'],
    selected: true
  },
  {
    id: 2,
    title: 'PRO',
    description:
      'Everything in FREE plus private decks, detailed analytics, no NuPitch watermark, script upload, cname, email support',
    img: bag,
    imgDark: bagDark,
    bg: bg9,
    darkBg: darkBg9,
    monthlyPrice: 100,
    yearlyPrice: 1000,
    features: ['3 users', '50 concurrent projects', '25 templates']
  },
  {
    id: 3,
    title: 'AGENCY',
    description:
      'Everything in Pro plus: premium stock assests, email DKIM, phone support',
    img: star,
    imgDark: starDark,
    bg: bg11,
    darkBg: darkBg11,
    monthlyPrice: 500,
    yearlyPrice: 5000,
    badge: {
      label: 'recommended',
      badgeBg: 'warning'
    },
    features: [
      '50 users',
      '500 concurrent projects',
      'Unlimited slides per deck',
      '<span class="fw-bold">Unlimited</span> templates'
    ]
  },
  {
    id: 4,
    title: '',
    description: '',
    img: shield,
    imgDark: shieldDark,
    bg: bg10,
    darkBg: darkBg10,
    monthlyPrice: 149.99,
    yearlyPrice: 1799.88,
    features: [
      '',
      '',
      '<span class="fw-bold">Unlimited</span> Members*',
      'Create & Share libraries',
      'Centralized billing'
    ]
  }
];
